import React, { memo, useMemo } from 'react';
import { Grid, MenuItem } from '@mui/material';
import FormTextField from './FormTextField';
import FormSelectField from './FormSelectField';
import { useTemplateConfig } from 'legacyfrontend/hooks/useTemplateConfig';

const FormPhoneField = memo(
  ({
    name,
    label,
    formik,
    required,
    error,
    helperText,
    onBlur,
    onChange,
    codigosPais,
    codigoWidth = '40%',
    numeroWidth = '60%',
  }) => {
    const { config } = useTemplateConfig();
    const defaultPhoneCode = config?.phonePrefix || '+54';
    const phoneValue = formik.values[name] || { codigo: defaultPhoneCode, numero: '' };
    const codigoValue = phoneValue.codigo;
    const numeroValue = phoneValue.numero;
    const codigoTouched = formik.touched[`${name}.codigo`] || (formik.touched[name] && formik.touched[name].codigo);
    const numeroTouched = formik.touched[`${name}.numero`] || (formik.touched[name] && formik.touched[name].numero);
    
    const codigoError = codigoTouched && (formik.errors[`${name}.codigo`] || (formik.errors[name] && formik.errors[name].codigo));
    const numeroError = numeroTouched && (formik.errors[`${name}.numero`] || (formik.errors[name] && formik.errors[name].numero));
    
    const codigoErrorMessage = codigoError || '';
    const numeroErrorMessage = numeroError || '';

    const handleCodigoChange = (e) => {
      const newValue = e.target.value;
      formik.setFieldValue(`${name}.codigo`, newValue, true);
      formik.setFieldValue(
        name,
        {
          ...phoneValue,
          codigo: newValue,
        },
        true
      );
      onChange?.(e);
    };

    const handleNumeroChange = (e) => {
      const newValue = e.target.value;
      formik.setFieldValue(`${name}.numero`, newValue, true);
      formik.setFieldValue(
        name,
        {
          ...phoneValue,
          numero: newValue,
        },
        true
      );
      onChange?.(e);
    };

    const handleBlur = (e) => {
      formik.handleBlur(e);
      onBlur?.(e);
    };

    const phoneCodesArray = Object.entries(codigosPais || {}).map(([value, label]) => ({
      value,
      label,
    }));

    return (
      <Grid container spacing={2}>
        <Grid item md={4} sx={{ width: codigoWidth }} xs={12}>
          <FormSelectField
            error={!!codigoError}
            formik={formik}
            label='Código'
            name={`${name}.codigo`}
            onBlur={handleBlur}
            onChange={handleCodigoChange}
            required={required}
            value={codigoValue}
          >
            {phoneCodesArray.map((codigo) => (
              <MenuItem key={codigo.value} value={codigo.value}>
                {codigo.label}
              </MenuItem>
            ))}
          </FormSelectField>
        </Grid>
        <Grid item md={8} sx={{ width: numeroWidth }} xs={12}>
          <FormTextField
            error={!!numeroError}
            formik={formik}
            helperText={numeroErrorMessage || (typeof helperText === 'string' ? helperText : '')}
            inputType='numeric'
            label={label}
            name={`${name}.numero`}
            onBlur={handleBlur}
            onChange={handleNumeroChange}
            placeholder='Ingrese el número'
            required={required}
          />
        </Grid>
      </Grid>
    );
  }
);

FormPhoneField.displayName = 'FormPhoneField';

export default FormPhoneField;
